import { ReloadOutlined } from '@ant-design/icons'
import { Button, Col, Empty, Input, Pagination, Row, message } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { withRouter } from 'react-router-dom'
import TableComponent from '../../components/Common/TableComponent'
import PageTitle from '../../components/PageTitle'
import UnreadText from '../../components/UnreadText/UnreadText'
import { systemName } from '../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  MODULE_CODE,
  getDOCUMENT_STATUS_RECEIVED,
} from '../../constants'
import DocumentsLayout from '../../layouts/DocumentsLayout'
import utils from '../../utils'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import {
  SearchBar,
  TableFooterActionWrapper,
} from './CateDocumentIncomingDocPageStyled'
import UnreadTextOutGoing from '../../components/UnreadText/UnreadTextOutGoing'

const { Search } = Input

const CateDocumentIncomingDocPage = props => {
  const {
    history,
    connectedCommitteeDocumentStore,
    loadingAnimationStore,
    authenticationStore,
    cateDocumentStore,
    moduleStore,
    aclStore,
  } = props

  const {
    incomingCommitteeDocumentListFilterByKeyword,
  } = connectedCommitteeDocumentStore

  const { currentUser } = authenticationStore
  const { isSuperAdmin, isAccountAdmin } = authenticationStore
  const { aclActionsByUser } = aclStore
  const { isAccessControl } = moduleStore

  const renderBussinessDocTypeName = typeId => {
    switch (typeId) {
      case '0':
        return 'Tạo văn bản mới'
      case '1':
        return 'Thu hồi văn bản đã gửi'
      case '2':
        return 'Cập nhật văn bản đã gửi'
      case '3':
        return 'Thay thế văn bản đã gửi'
      default:
        return ''
    }
  }

  const SCROLL_WIDTH = 1000

  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [disabledSearchBtn, setDisabledSearchBtn] = useState(true)
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [reload, setReload] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  let [searchOptionTitle, setSearchOptionTitle] = useState('')
  let [searchOption, setSearchOption] = useState({
    bussiness_doc_type: undefined,
    status: undefined,
    title: undefined,
    page: 0,
    size: 10,
  })

  const [reloadLoading, setReloadLoading] = useState(false)
  const [reloadStatusLoading, setReloadStatusLoading] = useState(false)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  const tableColumns = [
    {
      title: 'Số ký hiệu',
      width: 130,
      render: record => (
        <UnreadTextOutGoing
          text={record.documentNumber}
          isUnread={checkUnread(record)}
          width={130}
        />
      ),
    },
    {
      title: 'Tiêu đề',
      width: 400,
      render: record => (
        <UnreadTextOutGoing
          text={record.subject}
          isUnread={checkUnread(record)}
          width={400}
        />
      ),
    },
    {
      title: 'Nơi gửi',
      width: 150,
      render: record => (
        <UnreadTextOutGoing
          text={record.fromOrgan?.organName}
          isUnread={checkUnread(record)}
          width={150}
        />
      ),
    },
    {
      title: 'Trạng thái',
      width: 80,
      render: record => (
        <UnreadTextOutGoing
          text={getDOCUMENT_STATUS_RECEIVED(record?.statusId)}
          isUnread={checkUnread(record)}
          width={80}
        />
      ),
    },
    // {
    //   title: 'Nơi nhận',
    //   width: CO_QUAN_BAN_HANH_WIDTH,
    //   render: record => (
    //     <UnreadText
    //       text={record.organ_from}
    //       isUnread={checkUnread(record)}
    //       width={CO_QUAN_BAN_HANH_WIDTH}
    //     />
    //   ),
    // },
    {
      title: 'Ngày gửi',
      width: 70,
      render: record =>
        record.sendDate ? (
          <UnreadTextOutGoing
            text={moment(record.sendDate).format(DATE_FORMAT_DEFAULT)}
            isUnread={checkUnread(record)}
            width={70}
          />
        ) : null,
    },
    // {
    //   title: 'Nghiệp vụ',
    //   width: LOAI_NGHIEP_VU_WIDTH,
    //   render: record =>
    //     record.bussiness_doc_type ? (
    //       <UnreadText
    //         text={renderBussinessDocTypeName(record.bussiness_doc_type)}
    //         isUnread={checkUnread(record)}
    //         width={LOAI_NGHIEP_VU_WIDTH}
    //       />
    //     ) : null,
    // },
  ]

  const checkUnread = record => record.statusId == 1

  const reloadData = () => {
    setReloadLoading(true)
    cateDocumentStore
      .reload()
      .then(() => {
        message.success('Làm mới dữ liệu thành công')
        fetchData()
      })
      .finally(() => setReloadLoading(false))
  }

  const reloadStatus = () => {
    setReloadStatusLoading(true)
    cateDocumentStore
      .reloadStatus()
      .then(() => {
        message.success('Làm mới dữ liệu thành công')
        fetchData()
      })
      .finally(() => setReloadStatusLoading(false))
  }

  const handleSearch = values => {
    const { status, bussiness_doc_type, title } = values

    /** Kiểm tra việc reload lại trang để lấy lại list vb */
    if (title || bussiness_doc_type || status) {
      setReload(true)
    } else {
      setReload(false)
    }

    loadingAnimationStore.setTableLoading(true)
    cateDocumentStore
      .getDocumentsIncoming(searchOption)
      .finally(() => loadingAnimationStore.setTableLoading(false))
    setDisabledSearchBtn(true)
  }

  const onQuickSearch = useCallback(title => {
    let newSearchOption = {
      ...searchOption,
      ...{
        page: 0,
        title: title ? title.trim() : undefined,
      },
    }
    setSearchOption(newSearchOption)
    setDisabledSearchBtn(true)
  }, [])
  const onChangePagination = pageIndex => {
    let newSearchOption = {
      ...searchOption,
      ...{
        page: pageIndex - 1,
      },
    }
    setSearchOption(newSearchOption)
  }

  useEffect(() => {
    fetchData()
  }, [currentUser, searchOption, aclActionsByUser])

  const fetchData = useCallback(async () => {
    if (!currentUser) return
    if (aclActionsByUser.length === 0) return
    if (
      !isSuperAdmin &&
      !isAccountAdmin &&
      !isAccessControl(
        MODULE_CODE.lien_thong_vnpt,
        ACL_ACTION_TYPE.menu__VNPT,
        aclActionsByUser
      )
    ) {
      history.push('/dashboard')
      message.error(
        'Bạn không có quyền truy cập trang này, vui lòng liên hệ admin'
      )
      return
    }
    setTableLoading(true)
    await setCheckPagination(false)
    cateDocumentStore
      .getDocumentsIncoming(searchOption)
      .then(res => {
        setList(res.data.data)
        setTotal(res.data.total_count)
      })
      .finally(() => {
        setTableLoading(false)
        setCheckPagination(true)
      })
  }, [
    currentUser,
    searchOption,
    aclActionsByUser,
    isSuperAdmin,
    isAccountAdmin,
    history,
  ])

  return (
    <DocumentsLayout
      title={
        <PageTitle location={props.location} title="Văn bản đến" hiddenGoBack />
      }
      selectedKey="incoming-document"
      linkToIncomingDocument="/cate-document/incoming-document"
      linkToOutgoingDocument="/cate-document/outgoing-document"
      linkToConnectedCommitteeOrg="/cate/organization">
      <Helmet>
        <title>Văn bản đến | {systemName} Trục liên thông</title>
      </Helmet>
      <div>
        <Row>
          <Col span={12}>
            {!showAdvanceFilter ? (
              <SearchBar>
                <Search
                  allowClear
                  onSearch={onQuickSearch}
                  defaultValue={searchOptionTitle}
                  placeholder={'Tìm kiếm văn bản theo trích yếu'}
                  onChange={e => {
                    setSearchOptionTitle(e.target.value)
                  }}
                  value={searchOptionTitle}
                />
              </SearchBar>
            ) : null}
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            {/* <FilterButton
              type={showAdvanceFilter ? 'primary' : 'default'}
              ghost={showAdvanceFilter}
              onClick={() => setShowAdvanceFilter(!showAdvanceFilter)}
              style={{ marginBottom: showAdvanceFilter ? 5 : 0 }}>
              {showAdvanceFilter ? (
                <Space onClick={handleCloseAdvanceFilter}>
                  <CloseCircleOutlined />
                  Tắt tìm kiếm nâng cao
                </Space>
              ) : (
                <Space>
                  <FilterOutlined />
                  Tìm kiếm nâng cao
                </Space>
              )}
            </FilterButton>
            <Button
              loading={exportLoading}
              onClick={exportDocument}
              style={{ marginLeft: '10px' }}>
              <PrinterOutlined />
              In
            </Button> */}
            <Button
              loading={reloadLoading}
              onClick={reloadData}
              style={{ marginLeft: '10px' }}>
              <ReloadOutlined />
              Làm mới dữ liệu
            </Button>
            <Button
              loading={reloadStatusLoading}
              onClick={reloadStatus}
              style={{ marginLeft: '10px' }}>
              <ReloadOutlined />
              Làm mới trạng thái
            </Button>
          </Col>
        </Row>
        {showAdvanceFilter ? (
          <>
            <AdvanceFilterBlock
              onChangeSearchForm={value => {
                setSearchOption(Object.assign(searchOption, value))
                setDisabledSearchBtn(false)
              }}
              handleSearch={handleSearch}
              titleSearch={incomingCommitteeDocumentListFilterByKeyword}
              disabledSearchBtn={disabledSearchBtn}
            />
          </>
        ) : null}
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/cate-document/incoming-document/view/${record.id}`
                ),
            }
          }}
          rowKey={record => record.id}
          dataSource={list}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: SCROLL_WIDTH }}
          locale={{
            emptyText:
              checkPagination === true ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ) : (
                <div style={{ opacity: 0.1, height: '150px' }} />
              ),
          }}
          loading={tableLoading}
        />
        <TableFooterActionWrapper>
          {checkPagination === true ? (
            <Pagination
              onChange={e => onChangePagination(e)}
              pageSize={searchOption.size}
              showSizeChanger={false}
              showLessItems
              current={searchOption.page + 1}
              total={total}
              hideOnSinglePage={true}
            />
          ) : (
            ''
          )}
        </TableFooterActionWrapper>
      </div>
    </DocumentsLayout>
  )
}

CateDocumentIncomingDocPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'cateDocumentStore',
      'loadingAnimationStore',
      'authenticationStore',
      'connectedCommitteeDocumentStore',
      'moduleStore',
      'aclStore'
    )(observer(CateDocumentIncomingDocPage))
  )
)
